<div class="bruker">
  <button type="button" class="brukerinfo" (click)="byttDetaljvisning()" data-testid="ekspander-knapp">
    <avatar [bruker]="visningsbruker()" stil="liten"/>
    <span><strong>{{ visningsbruker().navnEllerEpost }}</strong><small>{{ visningsbruker().epost }} · {{ visningsbruker().mobilnummer }}</small></span>
  </button>
  @if (viserDetaljer()) {
    <section class="brukerdetaljer" data-testid="bruker-detaljer">
      @if (detaljer(); as detaljertBruker) {
          <tittel-verdi-samling stil="vertikal">
            <tittel-verdi stil="horisontal" tittel="ID" verdi="{{ detaljertBruker.id }}"/>
            <tittel-verdi stil="horisontal" tittel="Navn" verdi="{{ detaljertBruker.navn }}"/>
            <tittel-verdi stil="horisontal" tittel="brukernavn" verdi="{{ detaljertBruker.brukernavn }}"/>
            <tittel-verdi stil="horisontal" tittel="Epost" verdi="{{ detaljertBruker.epost }}"/>
            <tittel-verdi stil="horisontal" tittel="epostErBekreftet" verdi="{{ detaljertBruker.epostErBekreftet }}"/>
            <tittel-verdi stil="horisontal" tittel="mobilnummer" verdi="{{ detaljertBruker.mobilnummer }}"/>
            <tittel-verdi stil="horisontal" tittel="mobilnummerErBekreftet" verdi="{{ detaljertBruker.mobilnummerErBekreftet }}"/>
            <tittel-verdi stil="horisontal" tittel="Språk" verdi="{{ detaljertBruker.spraak }}"/>
            <tittel-verdi stil="horisontal" tittel="tidssone" verdi="{{ detaljertBruker.tidssone }}"/>
            <tittel-verdi stil="horisontal" tittel="openIdAutentiseringsmetoder" verdi="{{ openIdAutentiseringsmetoder().join(', ') }}"/>
            <tittel-verdi stil="horisontal" tittel="deaktiverteeMeldingstyper" verdi="{{deaktiverteMeldingstyper() }}"/>
          </tittel-verdi-samling>

          <section>
            <h3>{{ 'Elementer' | translate }}</h3>
            <table>
              <tr><th>Type</th><th>Opprettet</th><th>Endret</th><th>Slettet</th></tr>
              <tr><td>Møte</td><td>{{ stats().moeter.opprettet}}</td><td>{{ stats().moeter.endret}}</td><td>{{ stats().moeter.slettet}}</td></tr>
              <tr><td>Dokument</td><td>{{ stats().dokumenter.opprettet}}</td><td>{{ stats().dokumenter.endret}}</td><td>{{ stats().dokumenter.slettet}}</td></tr>
              <tr><td>Beslutninger</td><td>{{ stats().beslutninger.opprettet}}</td><td>{{ stats().beslutninger.endret}}</td><td>{{ stats().beslutninger.slettet}}</td></tr>
              <tr><td>Saker</td><td>{{ stats().saker.opprettet}}</td><td>{{ stats().saker.endret}}</td><td>{{ stats().saker.slettet}}</td></tr>
              <tr><td>Oppgaver</td><td>{{ stats().oppgaver.opprettet}}</td><td>{{ stats().oppgaver.endret}}</td><td>{{ stats().oppgaver.slettet}}</td></tr>
            </table>
        </section>
        <section><h3>{{ 'Autentiseringsmetoder' | translate }}</h3>
          <p>{{ autentiseringsmetoder().join(', ') }}</p></section>
        <section><h3>{{ 'Grupper' | translate }}</h3>
          @for (medlem of medlemskap(); track medlem.id) {
            <administrasjon-medlem [medlem]="medlem"/>
          }
        </section>
        <section><h3>{{ 'Handlinger' | translate }}</h3>
          <button *kreverTilgangsrolleBruker="'koble_brukere'" mat-raised-button color="primary" type="button" class="e2e-koblebrukere"
                  (click)="visKobleBrukereDialog()">{{ 'Koble brukere' | translate }}
          </button>
          <button mat-raised-button color="primary" type="button" class="e2e-glemtpassord" [disabled]="senderPassordreset() || passordresetSendt()"
                  (click)="sendPassordreset()">{{ 'Send glemt passord epost' | translate }}
          </button>
          @if (passordresetSendt()) {
            <p>{{ 'Epost sendt til {epost}' | translate:{epost: visningsbruker().epost} }}</p>
          }
        </section>
      }
      <administrasjon-bruker-hendeseslogg [brukerId]="bruker().id"/>
    </section>
  }
</div>
